import React from 'react';
import ReactLottie from '../BaseComponents/ReactLottie';

export default function AccountCreated() {
  const animationData = require('@assets/lottie_animation/partnerCreateAccountTick.json');
  return (
    <div className="d-flex justify-content-center">
      <ReactLottie options={{ loop: false, animationData }} />
    </div>
  );
}
